/* eslint-disable react/no-deprecated */
/// \file App.tsx
///
/// \par Copyright Notice:
/// Copyright (c) 2023 by Oshkosh Corporation.
/// All Rights Reserved.
///
/// \par
/// The information contained herein is confidential and proprietary property
/// of Oshkosh Corporation, and may be privileged.  The dissemination,
/// distribution, use, copying, transfer, or disclosure of such information is
/// strictly prohibited except by express written agreement with Oshkosh
/// Corporation, or with one of its subsidiaries.
import React, {Component} from "react";
import "bootstrap/dist/css/bootstrap.css";
import '@progress/kendo-theme-default/dist/all.css';
import "./App.css";
import { createBrowserRouter, createRoutesFromElements, RouterProvider } from "react-router-dom";
import routes from './routes/routes';
const router = createBrowserRouter(createRoutesFromElements(routes));
//initialize db
console.log("router: ",router);
class App extends Component<any, {apiResponse:string}> {
  constructor(props:any) {
    super(props);
    this.state = { apiResponse: "" };
  }

  callAPI() {
      const headers:any = {
        'Access-Control-Allow-Methods': 'GET, PUT, POST, DELETE, PATCH, OPTIONS',
        'Accept': 'text/html, application/json, text/plain, */*',
        'Access-Control-Expose-Headers': 'token, set-cookie',
        'cookie': document.cookie,
        "Content-Type":"application/json",
      }
      let path =  window.location.protocol+'//'+ window.location.hostname+":"+window.location.port;
      path = path+"/getVersion"
      fetch(path,{method:"GET",headers:headers})
          .then(async res => {
            const responseString = await res.text()
            this.setState({ apiResponse: responseString })
        });
  }

  componentWillMount() {
      this.callAPI();
  }

  render(){
    return(
    <div className="page-container">
      <div className="main-contents">
        <RouterProvider 
        router={router}
        />
      </div>
      <div className="footer" id="footer">
        <hr></hr>
        <h4>CMS <b>Version {this.state.apiResponse}</b></h4>
        <h4>Copyright {'\u00A9'} 2025 Oshkosh Corporation All Rights Reserved.</h4>
        <h4>Questions? Email: cmpsupport@oshkoshcorp.com</h4>
      </div>
    </div>
      );
  }
}

export default App;